
import {extent as d3_extent} from 'd3-array'
import {select as d3_select} from 'd3-selection'

export default function drawGradientRect($el, colorScale, size) {
  let gradient = d3_select($el).selectAll('.gradient').data([null])
  let gradientEnter = gradient.enter().append('svg').attr('class','gradient').attr('width',size.width).attr('height',size.height)
  
  let uniqueId = 'my-gradient-'+Math.round(Math.random()*9999)
  gradientEnter.append("defs").append("linearGradient").attr("id", uniqueId);
  
  gradientEnter.append("rect").attr('class','gradient-rect')
    
    
  gradient = gradient.merge(gradientEnter)
  
  gradient
    .attr("width", size.width)
    .attr("height", size.height)
  gradient.select('rect')
    .attr("width", size.width)
    .attr("height", size.height)
    
  let domain = colorScale.domain()
  let stepCount = 10
  let stepWidth = (domain[1]-domain[0])/stepCount
  let data = Array.from(Array(stepCount).keys()).map((d)=>{
    return {
      color: colorScale(domain[0]+d*stepWidth+stepWidth/2),
      value: d
    }
  })
  var extent = d3_extent(data, d => d.value);
  let linearGradient = gradient.select('defs').select('linearGradient')
  let stops = linearGradient.selectAll("stop")
    .data(data)
  let stopsEnter = stops.enter().append("stop")
    .attr("offset", d => (d.value/(extent[1] - extent[0]) * 100) + "%")
  stops.merge(stopsEnter).transition().attr("stop-color", d => d.color);
  let id = gradient.select("defs").select("linearGradient").attr("id")
  gradient.select('rect').style("fill", `url(#${id})` );
}